// extracted by mini-css-extract-plugin
module.exports = {"root":"ParticipantsListingPage_root__1_jB-"};